import { call, put, select } from 'redux-saga/effects';
import type { SignalingScreenshareWhiteboardPayload } from 'features/content-whiteboard/types';
import { initContentWhiteboardDataSaga } from 'features/content-whiteboard/sagas/initContentWhiteboardDataSaga';
import { requestScreenshareWhiteboardData } from 'features/content-whiteboard/actions';
import { contentBoard } from 'features/content-whiteboard/utils/contentBoardStateManager';
import { selectPreviewedFile } from 'features/content-library/contentLibrarySlice';
import { ContentLibraryOpenedFile } from 'features/content-library/types';

export function* initScreenshareWhiteboardDataSaga(data: SignalingScreenshareWhiteboardPayload) {
  // While a non-whiteboard file is being previewed, the contentBoard singleton
  // is bound to that preview. Cleaning + re-initialising it for the screenshare
  // would wipe the preview's bg image and shapes, turning the canvas black.
  // closePreviewContentLibraryFileSaga re-fetches via the active panel on
  // preview close, so the screenshare whiteboard catches up at that point.
  const previewedFile: ContentLibraryOpenedFile | null = yield select(selectPreviewedFile);
  if (previewedFile && previewedFile.type !== 'whiteboard') {
    return;
  }

  const { feedId, userId, shapes } = data;

  if (contentBoard.id) {
    yield call(contentBoard.clean);
  }

  yield call(initContentWhiteboardDataSaga, {
    type: 'screenshare',
    id: feedId,
    shapes,
    userId,
  });

  yield put(
    requestScreenshareWhiteboardData({
      feedId,
      userId,
    })
  );
}
